import './UnsubscribeSkeleton.scss';

const UnsubscribeSkeleton = () => {

  return (
    <div className="unsubscribe__wrapper__skeleton">
      <div className="logo__unsubscribe__skeleton"></div>
      <div className="unsubscribe__title__skeleton"></div>
      <div className="unsubscribe__subtitle__skeleton"></div>
      <div className="unsubscribe__buttons__skeleton">
        <div className="unsubscribe__button__skeleton"></div>
        <div className="unsubscribe__button__skeleton"></div>
      </div>
    </div>
  );
};

export default UnsubscribeSkeleton;